import type { Contact } from "../../types";

// Avatars are no longer auto-derived from a contact's email (the gravatar /
// favicon lookup was removed). Kept as a no-op so the data providers can keep
// calling it without special-casing; it always resolves to null.
export async function getContactAvatar(
  record: Partial<Contact>,
): Promise<string | null> {
  void record;
  return null;
}
